import { z } from 'zod';
import { isValidPersonName } from '../helpers';

const nameField = (requiredMsg: string, invalidMsg: string) =>
  z
    .string()
    .min(1, requiredMsg)
    .refine((val) => isValidPersonName(val.trim()), { message: invalidMsg });

export const profileSchema = z.object({
  firstName: nameField(
    'First name is required',
    'First name can only contain letters, hyphens, apostrophes, and spaces'
  ),
  lastName: nameField(
    'Last name is required',
    'Last name can only contain letters, hyphens, apostrophes, and spaces'
  ),
  email: z
    .string()
    .min(1, 'Email is required')
    .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Please enter a valid email address'),
  phone: z
    .string()
    .optional()
    .refine(
      (val) => {
        if (!val?.trim()) return true;
        const digits = val.replace(/\D/g, '');
        return digits.length === 0 || digits.length === 10;
      },
      { message: 'Phone number must be exactly 10 digits' }
    ),
});

export type ProfileSchemaData = z.infer<typeof profileSchema>;
